<div class="body-container mx-auto">
  <header>
    <h1 class="page-title text-center">
      Registration
    </h1>
  </header>
  <p class="page-subtitle text-center my-4">
    Now, let's pick your preferred Camp location.
  </p>
  <div class="px-3">
    <app-camp-location-search-select
      #searchSelect
      [isReg]="true"
      (selectedCampId)="handleSelectedCampId($event)"
    ></app-camp-location-search-select>
  </div>
  <hr>
  <div class="action-container">
    <button
      class="btn btn-danger btn-block"
      [ngClass]="{'disabled-btn': !isBtnEnabled}"
      (click)="onContinue()"
      [disabled]="!isBtnEnabled"
    >Save + Continue</button>
  </div>
</div>